import { render, staticRenderFns } from "./SchoolPrintConfig.vue?vue&type=template&id=3941fcc8"
import script from "./SchoolPrintConfig.vue?vue&type=script&lang=js"
export * from "./SchoolPrintConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3941fcc8')) {
      api.createRecord('3941fcc8', component.options)
    } else {
      api.reload('3941fcc8', component.options)
    }
    module.hot.accept("./SchoolPrintConfig.vue?vue&type=template&id=3941fcc8", function () {
      api.rerender('3941fcc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/SchoolPrintConfig.vue"
export default component.exports